import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import { format } from '@fs/zion-locale/date-fns'
import { i18n } from '@fs/zion-locale'
import { getComeUntoChristUrl } from '../../helpers/UrlHelper'

const legalCss = css`
  color: ${colors.text.secondary};
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
`

const legalLinkCss = css`
  &,
  &:visited,
  &:active,
  &:focus {
    color: ${colors.text.primary} !important;
    text-decoration: none;
  }
  &:hover {
    color: ${colors.text.primary};
    text-decoration: underline;
  }
`

export default function LegalText({ ...props }) {
  const [t] = useTranslation()
  const year = new Date().getFullYear()
  const termsOfUseDate = format(new Date(2019, 11, 10), 'yyyy-MM-dd')
  const privacyNoticeDate = format(new Date(2021, 3, 6), 'yyyy-MM-dd')

  return (
    <div css={legalCss} {...props}>
      <div>
        <Trans i18nKey="footer.terms-of-use" values={{ termsOfUseDate }}>
          <Link external to="https://www.familysearch.org/terms" css={legalLinkCss} linkName="footer_terms">
            FamilySearch Terms of Use
          </Link>
          (Updated 2019-12-10)
        </Trans>
        &nbsp;|&nbsp;
        <Trans i18nKey="footer.privacy-notice" values={{ privacyNoticeDate }}>
          <Link external to="https://www.familysearch.org/privacy" css={legalLinkCss} linkName="footer_privacy">
            Privacy Notice
          </Link>
          (Updated 2021-04-06)
        </Trans>
      </div>
      <div>
        {t('footer.copyright-notice', '© { year } by Intellectual Reserve, Inc. All rights reserved.', { year })}{' '}
        <Trans i18nKey="footer.service-by-church.link">
          A service provided by
          <Link
            to={getComeUntoChristUrl(i18n.language)}
            css={legalLinkCss}
            linkName="footer_service_provided_by_church"
            external
          >
            The Church of Jesus Christ of Latter-day Saints
          </Link>
        </Trans>
      </div>
    </div>
  )
}
